import React from 'react';
import { Text } from '@chakra-ui/react';
import { Condition } from './index';

export const ConditionB = React.memo(() => {
  return (
    <Condition>
      <Text
        fontWeight="bold"
        fontSize={{ base: 18, sm: 20, md: 18, lg: 20 }}
        color="pink.500"
        lineHeight={1.2}
      >
        兌換
        <br />
        <Text
          as="span"
          fontSize={{ base: 30, sm: 40, md: 30, lg: 40 }}
          display="inline"
        >
          200
        </Text>
        積分
      </Text>
    </Condition>
  );
});
